/* eslint-disable no-unused-vars */
import { axios } from '@/repositories'

const resource = '/v1/stay'
const resource_user = '/v1/users'
const resource_coupon = '/v1/coupon'
import menuStayParams from '../jsons-data/mocks/menu_stay_params.json'
// import me from '../jsons-data/mocks/me.json'


export default {
  async getMenuStayParams(menuNo, planId, roomId, checkInDay, checkOutDay, adultHeadCnt = 1, exUpperGradesHeadCnt = 0, exLowerGradesHeadCnt = 0, youjiAHeadCnt = 0,  youjiBHeadCnt = 0,  youjiCHeadCnt = 0,  youjiDHeadCnt = 0) {
    return new Promise((resolve, reject) => {
      const params = {
        checkInDay,
        checkOutDay,
        adultHeadCnt,
        exUpperGradesHeadCnt,
        exLowerGradesHeadCnt,
        youjiAHeadCnt,
        youjiBHeadCnt,
        youjiCHeadCnt,
        youjiDHeadCnt,
      }
      axios.get(`${resource}/menu/${menuNo}/plans/${planId}/rooms/${roomId}/stay-param`, { params }).then(
        (res) => {
          // resolve(menuStayParams)
          resolve(res.data)
        },
        (error) => {
          // resolve(menuStayParams)
          reject(error?.data)
        }
      )
    })
  },


  async getProfileInfo() {
    const me = {
      "familyName": "佐藤",
      "firstName": "一郎",
      "familyNameKana": "タナカ",
      "firstNameKana": "ハナコ",
      "defaultDestination": "0",
      "loginIdType": "0",
      "passwordReminderIsEnabled": true,
      "birthday": "2000-08-24T00:00:00.000+00:00",
      "sex": 1,
      "email": "zedera508@usako.net",
      "tel": "09091452097",
      "secondEmail": "dung.dinh@amela.vn",
      "secondTel": "0344059539",
      "addresses": [
          {
              "postalCode": "1000000",
              "prefectureCode": "13",
              "address1": "東京都千代田区",
              "address2": "１－１－２"
          },
          {
              "postalCode": "5390000",
              "prefectureCode": "27",
              "address1": "大阪府大阪市中央区",
              "address2": "１－１－１"
          }
      ],
      "addressUser": {
          "defaultDestination": 0,
          "addresses": [
              {
                  "postalCode": "1000000",
                  "prefectureCode": "13",
                  "address1": "東京都千代田区",
                  "address2": "１－１－２"
              },
              {
                  "postalCode": "5390000",
                  "prefectureCode": "27",
                  "address1": "大阪府大阪市中央区",
                  "address2": "１－１－１"
              }
          ]
      },
      "companyCd": "C1000707E",
      "companyName": "強制あり任意あり法人"
    }
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/profile/me`).then(
        (res) => {
          // resolve(me)
          resolve(res.data)
        },
        (error) => {
          // resolve(me)
          reject(error)
        }
      )
    })
  },
  async getAddress(zipcode) {
    const params = {
      zipcode
    }
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/address`, {params}).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.data)
        }
      )
    })
  },

  getTotalPoint(customerNo) {
    return axios.get(`${resource}/menus/${customerNo}`).then(
      (res) => { return res.data }).catch((error) => { 
      return error?.data
    })
  },

  getCoupon(memberId) {
    return axios.get(`${resource_coupon}/${memberId}`)
      .then((res) => { return res.data })
      .catch((error) => {
        return error?.data
      })
  },

  getProfileDetail(memberId) {
    return axios.get(`${resource_user}/member/${memberId}`)
      .then((res) => { return res.data })
      .catch((error) => {
        return error?.data
      })
  },

  getMemberInfo(userId) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource_user}/member/${userId}`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error?.data)
        }
      ).catch(() => {
      })
    })
  },

  getPointInfo(customerNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource_user}/member/${customerNo}/point`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  getBenePoint() {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/member/point`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  getMyCoupon() {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/coupon`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error?.data)
        }
      )
    })
  },

  getCouponList(isPastCoupon, page, sortBy, tab) {
    return new Promise((resolve, reject) => {
      const params = {
        isPastCoupon,
        page,
        sortBy,
        tab
      }
      // api/v1/coupon?isPastCoupon=false&page=1&sortBy=displayFrom&tab=0
      axios.get(`${resource}/coupon`, { params }).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          resolve(error?.data)
        }
      )
    })
  },

  getFavorite() {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/favorite`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          resolve(error?.data)
        }
      )
    })
  },

  getOrderHistory() {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/order/history`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          resolve(error?.data)
        }
      )
    })
  },

  getAccessHistory() {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/access/history`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          resolve(error?.data)
        }
      )
    })
  },

  getLocate() {
    return axios.get('/masterdata')
      .then((res) => { return res.data })
      .catch((error) => {
        return error?.data
      })
  },

  getItemsDetail() {
    return axios.get('/masterdata')
      .then((res) => { return res.data })
      .catch((error) => {
        return error?.data
      })
  },

  getCouponsDetail() {
    return axios.get('/masterdata')
      .then((res) => { return res.data })
      .catch((error) => {
        return error?.data
      })
  },

  getAllGiftCart() {
    return axios.get('/masterdata')
      .then((res) => { return res.data })
      .catch((error) => {
        return error?.data
      })
  },

  getMessageData() {
    return axios.get('/masterdata')
      .then((res) => { return res.data })
      .catch((error) => {
        return error?.data
      })
  }

}